import React from 'react';

/**
 * Rosette/seal badge with a checkmark cut-out. Sourced verbatim from Figma
 * (Clockout for Banks, node 5679:5505) and used for the monetization KPI
 * tiles: Total Non-Interest Income, Total DDS, Total New Direct Deposit Volume.
 *
 * Sized at `1em` so it scales with the parent's `font-size`, and filled with
 * `currentColor` so consumers control the color via CSS — white inside the
 * featured (navy gradient) KPI card, blue on the default white surface. The
 * checkmark is a cut-out, so the card background shows through it.
 */
function VerifiedSealIcon(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 35 34"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
            {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.3381 27.7381L12.4381 24.5381L8.83806 23.7381L9.18806 20.0381L6.73806 17.2381L9.18806 14.4381L8.83806 10.7381L12.4381 9.93806L14.3381 6.73806L17.7381 8.18806L21.1381 6.73806L23.0381 9.93806L26.6381 10.7381L26.2881 14.4381L28.7381 17.2381L26.2881 20.0381L26.6381 23.7381L23.0381 24.5381L21.1381 27.7381L17.7381 26.2881L14.3381 27.7381V27.7381M16.6881 20.7881L22.3381 15.1381L20.9381 13.6881L16.6881 17.9381L14.5381 15.8381L13.1381 17.2381L16.6881 20.7881V20.7881"
            />
        </svg>
    );
}

export default VerifiedSealIcon;
